import { useEffect } from "react";

export default function DMCAPolicy() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const last = "April 13, 2026";

  return (
    <div style={{ minHeight: "100vh", background: "#06060a", color: "#f0ede8", fontFamily: "'DM Sans', sans-serif", padding: "80px 24px" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500&family=DM+Serif+Display@0;1&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        h1 { font-family: 'DM Serif Display', serif; font-size: 36px; font-weight: 400; margin-bottom: 8px; }
        h2 { font-size: 16px; font-weight: 500; color: #f0ede8; margin: 32px 0 10px; }
        p { font-size: 14px; color: rgba(240,237,232,0.65); line-height: 1.8; margin-bottom: 12px; }
        ul { padding-left: 20px; margin-bottom: 12px; }
        li { font-size: 14px; color: rgba(240,237,232,0.65); line-height: 1.8; margin-bottom: 4px; }
        a { color: #7B5EA7; text-decoration: none; }
        hr { border: none; border-top: 0.5px solid rgba(255,255,255,0.07); margin: 32px 0; }
        .highlight { background: rgba(123,94,167,0.08); border: 0.5px solid rgba(123,94,167,0.2); border-radius: 10px; padding: 16px 20px; margin-bottom: 16px; }
      `}</style>

      <div style={{ maxWidth: 680, margin: "0 auto" }}>
        <a href="/" style={{ fontSize: 13, color: "rgba(240,237,232,0.4)", display: "inline-flex", alignItems: "center", gap: 6, marginBottom: 40 }}>← Back to Creator Protect</a>

        <h1>DMCA Policy</h1>
        <p style={{ fontSize: 13, color: "rgba(240,237,232,0.35)", marginBottom: 40 }}>Last updated: {last}</p>

        <p>Creator Protect respects intellectual property rights and complies with the Digital Millennium Copyright Act (DMCA). This page explains how we handle copyright infringement claims and how our platform helps creators protect their content.</p>

        <hr />

        <h2>1. How Creator Protect files DMCA notices</h2>
        <p>Creator Protect acts as an authorized DMCA agent on behalf of our subscribers. When our system detects unauthorized distribution of a creator's content, we automatically generate and deliver a formal DMCA takedown notice to the infringing platform. All notices are filed under Creator Protect's legal identity — the creator's personal information is never disclosed.</p>

        <div class="highlight">
          <p style={{ margin: 0, fontSize: 13 }}>Creator Protect has filed <strong style={{ color: "#f0ede8" }}>973+ DMCA notices</strong> on behalf of creators across <strong style={{ color: "#f0ede8" }}>30+ piracy platforms</strong>.</p>
        </div>

        <h2>2. Reporting copyright infringement to us</h2>
        <p>If you believe that content on our platform infringes your copyright, please send a written notice to our designated DMCA agent containing the following:</p>
        <ul>
          <li>A physical or electronic signature of the copyright owner or authorized agent</li>
          <li>Identification of the copyrighted work you claim has been infringed</li>
          <li>Identification of the material you claim is infringing, with enough detail for us to locate it</li>
          <li>Your contact information — address, telephone number, and email address</li>
          <li>A statement that you have a good faith belief that the use is not authorized</li>
          <li>A statement, under penalty of perjury, that the information in your notice is accurate and that you are the copyright owner or authorized to act on their behalf</li>
        </ul>

        <h2>3. Where to send DMCA notices</h2>
        <p>Send DMCA notices to our designated agent:</p>
        <p>Email: <a href="mailto:dmca@creatorprotect.io">dmca@creatorprotect.io</a></p>
        <p>We will respond to valid DMCA notices within 72 hours.</p>

        <h2>4. Counter-notification</h2>
        <p>If you believe your content was removed in error, you may submit a counter-notification to dmca@creatorprotect.io containing:</p>
        <ul>
          <li>Your physical or electronic signature</li>
          <li>Identification of the material that was removed and its location before removal</li>
          <li>A statement under penalty of perjury that you have a good faith belief the material was removed by mistake</li>
          <li>Your name, address, and telephone number</li>
          <li>A statement consenting to the jurisdiction of the Federal District Court for your district</li>
        </ul>

        <h2>5. Repeat infringers</h2>
        <p>Creator Protect maintains a repeat infringer policy. Accounts found to repeatedly infringe copyright will be terminated.</p>

        <h2>6. False notices</h2>
        <p>Under Section 512(f) of the DMCA, any person who knowingly materially misrepresents that material is infringing may be liable for damages. Do not submit false DMCA notices.</p>

        <hr />
        <p style={{ fontSize: 12, color: "rgba(240,237,232,0.25)" }}>© 2026 Creator Protect. All rights reserved.</p>
      </div>
    </div>
  );
}
